module.exports = __webpack_public_path__ + "img/img_32389_0_463.9d1a8b9b.png";